/**
 * Zeffy Donation Integration Configuration
 *
 * Environment-based configuration for Zeffy pop-up donation forms
 * See: https://support.zeffy.com/how-do-i-share-my-form
 */

/**
 * Get the Zeffy form link from environment variables
 * This is the zeffy-form-link URL from Zeffy dashboard
 * Example: https://www.zeffy.com/embed/donation-form/ncesp-website-launch-campaign?modal=true
 */
export const getZeffyFormLink = (): string => {
  const formLink = import.meta.env.VITE_ZEFFY_FORM_LINK
  if (!formLink) {
    console.warn(
      'VITE_ZEFFY_FORM_LINK not configured. Zeffy donations will not work.'
    )
    return ''
  }
  return formLink
}

/**
 * Check if Zeffy is properly configured
 */
export const isZeffyConfigured = (): boolean => {
  return !!import.meta.env.VITE_ZEFFY_FORM_LINK
}
